import { faCirclePlus, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import "./HeaderButtonsScheduleEmail.css"
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState, useAppDispatch } from '../../../redux/store/store'
import { useTranslation } from 'react-i18next'
import { GetScheduleEmailsThunk } from '../../../redux/slices/components/ScheduleEmails/scheduleEmailsSlice'

const HeaderButtonsScheduleEmail = () => {

    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const activated = useSelector((state: RootState) => state.scheduleEmailsData.activated)
    const countActivated = useSelector((state: RootState) => state.scheduleEmailsData.countActivated)
    const countDeactivated = useSelector((state: RootState) => state.scheduleEmailsData.countDeactivated)

    const onGoCreate = () => {
        navigate("/schedule-emails/create")
    }

    const onGetActivated = () => {
        dispatch( GetScheduleEmailsThunk(1) )
    }

    const onGetDeactivated = () => {
        dispatch( GetScheduleEmailsThunk(0) )
    }

    return (
        <div className="">

            <p className="fs-18 fw-700 mb-20">{t("Emails:schedule:index:label_20")}</p>

            <div className="flex flex-jc-sb">

                <div className="flex">

                    <div className="p-relative">
                        <div className="p-absolute active-bg pt-3 pb-3 pl-6 pr-6 border-radius-8" style={{ right: "-1rem", top: "-1rem" }}>
                            <p className="c-white fw-600 fs-11" >{countActivated}</p>
                        </div>
                        <button 
                            onClick={onGetActivated}
                            className={`${activated ? "btn-pending-clicked" : "btn-pending"} fs-14 fw-600 pr-16 pl-16 border-radius-6`}
                        >
                            {t("Emails:schedule:index:label_21")}
                        </button>
                    </div>

                    <div className="p-relative ml-18">
                        <div className="p-absolute error-bg pt-3 pb-3 pl-6 pr-6 border-radius-8" style={{ right: "-1rem", top: "-1rem" }}>
                            <p className="c-white fw-600 fs-11" >{countDeactivated}</p>
                        </div>
                        <button 
                            onClick={onGetDeactivated}
                            className={`${!activated ? "btn-pending-clicked" : "btn-pending"} fs-14 fw-600 pr-16 pl-16 border-radius-6`}
                        >
                            {t("Emails:schedule:index:label_22")}
                        </button>
                    </div>

                </div>


                    
                <button
                    onClick={onGoCreate} 
                    className="btn-pending fs-14 fw-600 pr-16 pl-16 border-radius-6 flex flex-ai-center"
                >
                    <div className="circle-plus-notif center mr-10">
                        <FontAwesomeIcon 
                            icon={faPlus}
                            className="fs-16"
                        />
                    </div>
                    {t("Emails:schedule:index:label_23")}
                </button>


            </div>

        </div>
    )
}

export default React.memo( HeaderButtonsScheduleEmail )